export const NumberTextFormatter = (item: number) => {
    const itemString = item.toString()

    return itemString.padStart(2, '0')
}